import { Button, Icon, useDisclosure } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';
import { FaFileExport } from 'react-icons/fa';

import ExportModal from './ExportModal';

/**
 * ExportButton - drop-in trigger for the shared export dialog (RAT-1865).
 * A section integrates by passing its entity key, current filter params and
 * the columns currently visible in its table (for the "Match table" preset)
 * — no export logic is written per section.
 */
const ExportButton = ({
  entity,
  title,
  currentFilters = {},
  filteredTotal,
  matchTableKeys = [],
  ...buttonProps
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button
        bg="reviveOrange"
        color="white"
        borderRadius="12px"
        _hover={{ bg: 'reviveOrange', opacity: 0.8 }}
        leftIcon={<Icon as={FaFileExport} w="15px" h="15px" />}
        onClick={onOpen}
        width={{ base: '100%', sm: 'auto' }}
        {...buttonProps}
      >
        Export
      </Button>
      {isOpen && (
        <ExportModal
          isOpen={isOpen}
          onClose={onClose}
          entity={entity}
          title={title}
          currentFilters={currentFilters}
          filteredTotal={filteredTotal}
          matchTableKeys={matchTableKeys}
        />
      )}
    </>
  );
};

ExportButton.propTypes = {
  entity: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  currentFilters: PropTypes.object,
  filteredTotal: PropTypes.number,
  matchTableKeys: PropTypes.arrayOf(PropTypes.string),
};

export default ExportButton;
